(() => {
  if (window.shirtyNativeNavigation) return;
  window.shirtyNativeNavigation = true;
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!item.matches?.('.sn-disclosure') || !item.open) return;
    item.closest('[data-sn-nav]').querySelectorAll('.sn-disclosure[open]').forEach(other => {
      if (other !== item) other.open = false;
    });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const item = event.target.closest?.('.sn-disclosure[open]');
    if (item) {
      event.preventDefault();
      event.stopImmediatePropagation();
      item.open = false;
      item.querySelector('summary').focus();
    }
  }, true);
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.sn-nav--desktop .sn-disclosure[open]').forEach(item => {
      if (!item.contains(event.target)) item.open = false;
    });
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('.sn-nav--desktop .sn-disclosure[open]').forEach(item => {
      if (!item.contains(event.target)) item.open = false;
    });
  });
})();
